import NavBar from "../Homepage/LandingPage/NavBar";
import SignIn from "./SignIn";
import hero from "../../img/Hero/Hero.png";
import { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import SignUp from "./SignUp";
import CreatAccComp from "./CreatAccComp";
import CreatAccInd from "./CreateAccInd";
function Auth() {
    // This flag controller controls just controlls which view user is looking at
    // i could have used router but i cant animate things in and out like that
    // so using flag seems to be the best optionn
    const [View, setView] = useState(null);

    const Auth_Wrapper = useRef();
    useEffect(() => {
        // this just waits a bit before setting flag i.e before starting the animation
        setTimeout(() => {
            setView("sign_in");
        }, 500);
        return () => {
            setView(null);
        };
    }, []);
    return (
        <div id="auth">
            <div
                className="auth_wrapper"
                ref={Auth_Wrapper}
                style={{ backgroundImage: `url(${hero})` }}
            >
                <NavBar />
                {/* Diffrent Views */}
                <CSSTransition in={View === "sign_in"} unmountOnExit timeout={400}>
                    <SignIn view_controller={View} setController={setView} />
                </CSSTransition>
                <CSSTransition in={View === "sign_up"} unmountOnExit timeout={400}>
                    <SignUp view_controller={View} setController={setView} />
                </CSSTransition>
                <CSSTransition in={View === "create_acc_comp"} unmountOnExit timeout={400}>
                    <CreatAccComp
                        view_controller={View}
                        setController={setView}
                        auth_wrapperRef={Auth_Wrapper}
                    />
                </CSSTransition>
                <CSSTransition in={View === "create_acc_ind"} unmountOnExit timeout={400}>
                    <CreatAccInd
                        view_controller={View}
                        setController={setView}
                        auth_wrapperRef={Auth_Wrapper}
                    />
                </CSSTransition>
            </div>
        </div>
    );
}

export default Auth;
